// Scripting for sliders or carousels (Baytek gutenblocks plugin includes a slider block that uses slick slider)
(function($){
    $('.logo-slider').slick('unslick'); // unslick to remove the slick controls added via gutenblocks so we can customize
	$('.logo-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
		arrows: true,
		dots: false,
		prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous"></button>',
		nextArrow:'<button class="slick-next slick-arrow" aria-label="Next"></button>',
	  	responsive: [{
			breakpoint: 1000,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			}
		},{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	});

})(jQuery);
